export default {
    anspruch: 'Unser Anspruch',
    praemien: 'Deine Prämien',
    datenschutz: 'Datenschutz',
    impressum: 'Impressum',
    support: 'Support',
    nutzungsbedingungen: 'Nutzungsbedingungen',
    pflichttexte: 'Pflichttexte',
};
